module.exports = FaroReact;